import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
import {ThirdParty} from '../../entity/third-party';


@Injectable()
export class RelationSearchService {

    private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private http: InterceptorService) { }

    searchThirdPartyByRelation(thirdPartySearch, relationDestination, thirdPartyRelationType) {
        const params = {
            'search': thirdPartySearch,
            'relationDestination': relationDestination,
            'thirdPartyRelationType': thirdPartyRelationType
        };

        return this.http.post(
            environment.apiUrl + 'site-api/customer-infos/get_third_party_by_relation',
            JSON.stringify(params),
            {headers: this.headers}
            )
            .map(function(response) {
                const producers = [];
                const thirdParty = response.json();
                return thirdParty;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./src/app/customer-infos/relation-search/relation-search.service.ts